import React, { useState } from "react";
import { db,storage } from "../../FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

function EventForm() {
  const [event, setEvent] = useState({
    title: "",
    date: "",
    description: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleEventSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let imageUrl = "";
      if (event.image) {
        const imageRef = ref(storage, `events/${event.image.name}`);
        const uploadTask = uploadBytesResumable(imageRef, event.image);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            null,
            (error) => reject(error),
            async () => {
              imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve();
            }
          );
        });
      }

      await addDoc(collection(db, "events"), {
        title: event.title,
        date: event.date,
        description: event.description,
        imageUrl,
        createdAt: new Date(),
      });

      alert("Event posted successfully!");
      setEvent({ title: "", date: "", description: "", image: null });
      setImagePreview(null);
    } catch (error) {
      console.error("Error posting event:", error);
      alert("Failed to post the event.");
    }

    setLoading(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEvent({ ...event, image: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <div>
      <h3 className="text-2xl font-bold mb-6">Post an Upcoming Event</h3>
      <form onSubmit={handleEventSubmit} encType="multipart/form-data">
        <input
          type="text"
          placeholder="Event Title"
          value={event.title}
          onChange={(e) => setEvent({ ...event, title: e.target.value })}
          required
          className="block w-full p-2 mb-3 border border-gray-300 rounded"
        />
        <input
          type="date"
          value={event.date}
          onChange={(e) => setEvent({ ...event, date: e.target.value })}
          required
          className="block w-full p-2 mb-3 border border-gray-300 rounded"
        />
        <textarea
          placeholder="Event Description (Max 30 words)"
          value={event.description}
          onChange={(e) => {
            const wordCount = e.target.value.split(/\s+/).filter(Boolean).length;
            if (wordCount <= 30) {
              setEvent({ ...event, description: e.target.value });
            }
          }}
          rows="4"
          required
          className="block w-full p-2 mb-3 border border-gray-300 rounded"
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
          className="block mb-3"
        />
        {imagePreview && (
          <img src={imagePreview} alt="Preview" className="w-full h-auto mb-3 border rounded" />
        )}
        <button
          type="submit"
          className="p-2 bg-indigo-600 text-white rounded"
          disabled={loading}
        >
          {loading ? "Uploading..." : "Submit Event"}
        </button>
      </form>
    </div>
  );
}

export default EventForm;
